import { render } from "./creation.vue?vue&type=template&id=653f6d6a"
import script from "./creation.js?vue&type=script&lang=js&external"
export * from "./creation.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__